// tenant-storage.ts
export const TENANT_KEY = 'ikreate:tenant';

export function getTenantLS(): string | null {
  try {
    return localStorage.getItem(TENANT_KEY);
  } catch {
    return null;
  }
}

export function setTenantLS(tenant: string | null) {
  try {
    if (!tenant) localStorage.removeItem(TENANT_KEY);
    else localStorage.setItem(TENANT_KEY, tenant);
  } catch {
    // ignore
  }
}

export function deleteTenantLS() {
  try {
    localStorage.removeItem(TENANT_KEY);
  } catch {
    // ignore
  }
}
